module.exports = __webpack_public_path__ + "bedeacb0d352c07b397e65a3fcc4a1f6.pdf";